<template>
  <div class="strategy-page">

    <strategy-hero-section
      :fields="strategyPageSections.sections.strategy_hero_section.fields"
    />

    <strategy-divider-section
      :fields="strategyPageSections.sections.strategy_divider_section.fields"
    />

    <strategy-cover-section
      :fields="strategyPageSections.sections.strategy_cover_section.fields"
    />

    <strategy-text-section
      :fields="strategyPageSections.sections.strategy_text_section.fields"
    />

    <strategy-divider2-section
      :fields="strategyPageSections.sections.strategy_divider2_section.fields"
    />

    <strategy-text2-section
      :fields="strategyPageSections.sections.strategy_text_2_section.fields"
    />

    <strategy-divider3-section
      :fields="strategyPageSections.sections.strategy_divider3_section.fields"
    />

    <strategy-feature-section
      :fields="strategyPageSections.sections.strategy_features_section.fields"
    />


    <strategy-divider4-section
      :fields="strategyPageSections.sections.strategy_divider4_section.fields"
    />

    <strategy-feature2-section
      :fields="strategyPageSections.sections.strategy_features_2_section.fields"
    />

    <strategy-divider5-section
      :fields="strategyPageSections.sections.strategy_divider5_section.fields"
    />

    <strategy-text3-section
      :fields="strategyPageSections.sections.strategy_text_3_section.fields"
    />

    <strategy-divider6-section
      :fields="strategyPageSections.sections.strategy_divider6_section.fields"
    />

    <strategy-test4-section
      :fields="strategyPageSections.sections.strategy_text_4_section.fields"
    />

    <strategy-divider7-section
      :fields="strategyPageSections.sections.strategy_divider7_section.fields"
    />

    <strategy-text5-section
      :fields="strategyPageSections.sections.strategy_text_5_section.fields"
    />

    <strategy-call-to-action-section
      :fields="strategyPageSections.sections.strategy_call_to_action_section.fields"
    />

    <strategy-divider8-section
      :fields="strategyPageSections.sections.strategy_divider8_section.fields"
    />

    <strategy-text6-section
      :fields="strategyPageSections.sections.strategy_text_6_section.fields"
    />

    <strategy-divider9-section
      :fields="strategyPageSections.sections.strategy_divider9_section.fields"
    />

    <strategy-call-to-action2-section
      :fields="strategyPageSections.sections.strategy_call_to_action_2_section.fields"

    />

  </div>
</template>

<script>

import DividerSection from "/seu-frontend/sections/general/DividerSection";
import StrategyHeroSection from "/seu-frontend/sections/strategy-page/StrategyHeroSection";
import StrategyCoverSection from "/seu-frontend/sections/strategy-page/StrategyCoverSection";
import StrategyTextSection from "/seu-frontend/sections/strategy-page/StrategyTextSection";
import StrategyText2Section from "/seu-frontend/sections/strategy-page/StrategyText2Section";
import StrategyCallToActionSection from "/seu-frontend/sections/strategy-page/StrategyCallToActionSection";
import StrategyText3Section from "/seu-frontend/sections/strategy-page/StrategyText3Section";
import StrategyTest4Section from "/seu-frontend/sections/strategy-page/StrategyText4Section";
import StrategyText5Section from "/seu-frontend/sections/strategy-page/StrategyText5Section";
import StrategyText6Section from "/seu-frontend/sections/strategy-page/StrategyText6Section";
import StrategyCallToAction2Section from "/seu-frontend/sections/strategy-page/StrategyCallToAction2Section";
import StrategyFeatureSection from "/seu-frontend/sections/strategy-page/StrategyFeatureSection";
import StrategyFeature2Section from "/seu-frontend/sections/strategy-page/StrategyFeature2Section";
import StrategyDividerSection from "/seu-frontend/sections/strategy-page/StrategyDividerSection";
import StrategyDivider2Section from "/seu-frontend/sections/strategy-page/StrategyDivider2Section";
import StrategyDivider3Section from "/seu-frontend/sections/strategy-page/StrategyDivider3Section";
import StrategyDivider4Section from "/seu-frontend/sections/strategy-page/StrategyDivider4Secion";
import StrategyDivider5Section from "/seu-frontend/sections/strategy-page/StrategyDivider5Section";
import StrategyDivider7Section from "/seu-frontend/sections/strategy-page/StrategyDivider7Section";
import StrategyDivider6Section from "/seu-frontend/sections/strategy-page/StrategyDivider6Section.vue";
import StrategyDivider8Section from "/seu-frontend/sections/strategy-page/StrategyDivider8Section";
import StrategyDivider9Section from "/seu-frontend/sections/strategy-page/StrategyDivider9Section";

export default {
  name: "StrategyPage",
  components: {
    StrategyDivider9Section,
    StrategyDivider8Section,
    StrategyDivider6Section,
    StrategyDivider7Section,

    StrategyDivider5Section,
    StrategyDivider4Section,
    StrategyDivider3Section,
    StrategyDivider2Section,
    StrategyDividerSection,
    StrategyFeature2Section,
    StrategyFeatureSection,
    StrategyCallToAction2Section,
    StrategyText6Section,
    StrategyText5Section,
    StrategyTest4Section,
    StrategyText3Section,
    StrategyCallToActionSection,
    StrategyText2Section,
    StrategyTextSection,
    StrategyCoverSection,
    StrategyHeroSection,
    DividerSection,
  },
  data: () => ({
    buttonIcon: require('../assets/icons/arrow-white-right.svg')
  }),
  computed: {
    strategyPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/strategyPage`).default;
    }
  },
  metaInfo() {
    return {
      title: this.strategyPageSections.title,
    }
  }
}
</script>

<style lang="scss">
@import "StrategyPage";
</style>
